import React from 'react';
import { useSelector } from 'react-redux';
import Layout from '../../../layout';
import { EDevice } from '../../../redux/sequence/enums';
import { RootState } from '../../../redux/store';
import ArrowList from '../../b2b/components/arrow-list/arrow-list';
import OldButton from '../../b2b/components/button/button';
import Contact from '../contact/contact';
import { ReactComponent as CreditFailedSvg } from '/src/assets/svg/credit_check_failed.svg';
import { ReactComponent as CreditFailedSmall } from '/src/assets/svg/credit_check_failed_small.svg';

const StatusFailed: React.FC = () => {
  const { device } = useSelector((state: RootState) => state.sequence);

  const headline = (
    <>
      {device === EDevice.MOBILE && (
        <CreditFailedSmall className='status-svg mb-6' />
      )}
      <div>Dein Leasingantrag kann aktuell nicht genehmigt werden</div>
    </>
  );

  const getSubHeading = () => {
    return 'Aufgrund der von dir gemachten Angaben, können wir dir leider keinen Leasingvertrag anbieten.';
  };

  return (
    <Layout
      heading={headline}
      subHeading={getSubHeading()}
      hasFullSize={true}
      className='status-overview top-96 grid'
      style={{ gridTemplateRows: '15% 60%' }}
    >
      <div
        className='half-half-columns cancelled top-36'
        style={{ alignItems: 'start' }}
      >
        {(device === EDevice.DESKTOP || device === EDevice.TABLET) && (
          <CreditFailedSvg className='status-svg' />
        )}
        <div className='flex flex-col gap-4'>
          <div className='content-bold'>Was du jetzt tun kannst</div>

          <ArrowList
            className='dark-grey content-normal'
            list={[
              'Solltest du weiterhin Interesse an einem Leasingvertrag haben, findest du auf unserem mobility portal eine passende Alternative.',
            ]}
          />

          <OldButton
            type='button'
            onClick={() => window.open(import.meta.env.VITE_MOPO_URL, '_self')}
            style={{
              width: '100%',
              marginTop: '18px',
              marginBottom: '18px',
            }}
          >
            <span className='content-bold text-base!'>Zur Fahrzeugsuche</span>
          </OldButton>

          <Contact />
        </div>
      </div>
    </Layout>
  );
};

export default StatusFailed;
